import React from 'react';
import styled from 'styled-components';

import Button from '@catalogo/ui-americanas-desktop-button';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 0 25px;
  background: #fff;
`;

const Title = styled.p`
  flex: 1;
  font-size: 20px;
  color: ${({ theme }) => theme.textColor};
  font-weight: ${({ theme }) => theme.fontWeight.title};
`;

const WrapperButton = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
`;

const ButtonUI = styled(Button)`
  border: 2px solid ${({ theme }) => theme.primaryColor};
  color: ${({ theme }) => theme.primaryColor};
  text-transform: ${({ theme }) => theme.btnTextTransform};
  width: 300px;
  font-weight: ${({ theme }) => theme.btnTextWeigth};
  cursor: pointer;

  & :hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

export const MakeQuestion = ({ title, hasCustomerQuestions, productId }) => {
  if (hasCustomerQuestions) {
    return null;
  }

  return (
    <Wrapper>
      <Title>{title}</Title>
      <WrapperButton>
        <ButtonUI
          href={`/perguntar/${productId}`}
          width="200px"
          height="45px"
          title="Escrever pergunta"
          borderRadius="8px"
          fontSize="16px"
        />
      </WrapperButton>
    </Wrapper>
  );
};
